export default {
  updateBasketItemComment (state, { index, value }) {
    state.basket[index].comment = value;
  },

  updateBasketServices (state, data) {
    state.basketServices = data;
  },

  updateSumCalculate (state, data) {
    state.sumCalculate = data;
  },

  updateBasketLS(state, data) {
    state.basket = data;
  },

  updateBasketEdit(state, val) {
    state.basketEdit.index = val.index;
    state.basketEdit.state = val.state;
  },

  updateBasketEditOrder(state, val) {
    state.basketEditOrder = val;
  },

  updateBasketServicesData(state, val) {
    state.basketServicesData = val;
  },

  updateBasket (state, val) {
    let data = val.data;
    if (val.index !== '') {
      state.basket.splice(val.index, 1, val.data)
    } else {
      state.basket.push(data);
    }
  },

  updateBasketAccountOrder(state, data) {
    state.basket = [];
    for(let i = 0; i < data.items.length; i++){
      state.basket.push({
        'hash': data.items[i].hash,
        'id': data.items[i].id,
        ...data.items[i],
      });
    }
  },

  updateBasketOrder(state, data) {
    state.basketOrder = data;
  },

  deleteBasketItem(state, index) {
    state.basket.splice(index, 1);
  },

  clearBasket(state) {
    state.basket = [];
  },

  countIncrease(state, index) {
    state.basket[index].quantity++;
  },

  countReduce(state, index) {
    state.basket[index].quantity--;
  },

  updateCurrency(state, val) {
    if (!val || (val && val.length > 1)) {
      state.currency = '₽';
    } else {
      state.currency = val;
    }
  },

  updateBasketDiscountPercent(state, data) {
    for (let i = 0; i < state.basket.length; i++) {
      if (state.basket[i] && data[i]) {
        state.basket[i].parameters.discount.size = data[i].discount;
        state.basket[i].parameters.discount.price = data[i].priceWithDiscount;
      }
    }
  },

  updateBasketDiscountType(state, val) {
    state.basket[val.index].parameters.discount.type = val.type;
    state.basket[val.index].parameters.discount.percent = val.size;
  },

  updateCurrencyLabel(state, val) {
    if (val && state.currencyLabel !== val) {
      state.currencyLabel = val;
      state.basketDiscountValue.push({
        label: `Скидка в ${val}`,
        value: 1,
      })
    }
  },

  updateBasketDiscount(state, val) {
    state.basket[val.index].parameters.discount.size = val.size;
    state.basket[val.index].parameters.discount.price = val.price;
  },

  updateSumCalculateDisable(state, val) {
    state.sumCalculateDisable = val;
  },
}
